/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoMangimeUpdateDTO
 */
export interface TipoMangimeUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof TipoMangimeUpdateDTO
     */
    descrizione: string;
}

/**
 * Check if a given object implements the TipoMangimeUpdateDTO interface.
 */
export function instanceOfTipoMangimeUpdateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "descrizione" in value;

    return isInstance;
}

export function TipoMangimeUpdateDTOFromJSON(json: any): TipoMangimeUpdateDTO {
    return TipoMangimeUpdateDTOFromJSONTyped(json, false);
}

export function TipoMangimeUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoMangimeUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'],
    };
}

export function TipoMangimeUpdateDTOToJSON(value?: TipoMangimeUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
    };
}

